module.exports = __webpack_public_path__ + "img/L.a1f550d3.jpg";